import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter, Switch, Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';

import AnalyseApp from 'AnalyseApp';
import {
  ROUTE_LOGIN,
  ROUTE_SIGNUP,
  ROUTE_FORGOT,
  ROUTE_DISCOVER,
  ROUTE_TIPS,
  ROUTE_ANALYSE,
  ROUTE_USERS,
  ROUTE_PROFILE,
  ROUTE_SET_PASSWORD,
  ROUTE_DISCOVER_RESULT_PDF
} from 'RouteList';

import Login from 'containers/login/Login';
import SignupView from 'containers/login/SignupView';
import SetPasswordView from './containers/login/SetPasswordView';
import ForgotLoginView from 'containers/login/ForgotLoginView';
import PrivateRoute from 'containers/PrivateRoute';
import LoginRoute from 'containers/LoginRoute';
import Users from 'containers/users/Users';
import Alert from 'components/Alert/Alert';
import LoaderOverlay from 'components/LoaderOverlay/LoaderOverlay';
import Drawer from 'components/Drawer/Drawer';
import DrawerHeader from 'components/Drawer/DrawerHeader';
import Navigation from 'components/Navigation/Navigation';
import NavigationItem from 'components/Navigation/NavigationItem';
import NavigationLogoutWrapper from 'components/Navigation/NavigationLogout';

import { drawerItems } from 'DrawerList';
import Home from 'containers/static/Home';
import Discover from 'containers/discover/Discover';
import Tips from 'containers/tips/Tips';
import Profile from 'containers/profile/Profile';

import Icon from 'components/Icon/Icon';
import styled from 'styled-components';
import { Flex } from 'grid-styled';
import ResultPDFView from './containers/discover/ResultPDFView';

const LogoWrapper = styled.div`
  position: relative;
  text-align: center;
  display: block;
  margin-top: 20px;

  svg {
    width: 80%;
    max-height: 50px;
  }
`;

const ContactGroup = styled.ul`
  list-style: none;
  font-family: ${props => props.theme.fonts.fontface};
  text-transform: uppercase;
  font-size: ${props => props.theme.fonts.sizeSmall};
  padding: 0 10px 0 30px;

  li {
    padding: 0;
  }
`;

const ContactWrapper = styled.div`
  background: white;
  padding: 30px 0 0;
  align-self: flex-end;
`;
@withRouter
@inject('routing', 'authStore', 'uiState')
@observer
export default class AppRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  logout = () => {
    const { routing: { push }, authStore } = this.props;
    if (authStore.isImpersonator) {
      authStore.unsetImpersonator();
      push(ROUTE_USERS);
    } else {
      authStore.logout();
    }
  };

  render() {
    const { authStore, routing, location, uiState } = this.props;
    const { isLoggedIn, user, tmpCognitoUser, isImpersonator } = authStore;
    const { appIsInSync, isMenuOpen, alertModel } = uiState;
    const { push } = routing;
    const currentUser = isImpersonator || user;
    let drawerItemsFiltered = drawerItems;
    // filter out non admin routes
    if (currentUser && !currentUser.admin) {
      drawerItemsFiltered = drawerItems.filter(item => !item.admin);
    }

    const showDrawer = location.pathname !== ROUTE_DISCOVER_RESULT_PDF;

    return (
      <React.Fragment>
        {!appIsInSync && <LoaderOverlay white />}
        {alertModel && <Alert {...alertModel} />}
        {isLoggedIn &&
          showDrawer && (
            <Drawer show={isMenuOpen} onClick={() => uiState.hideMenu()}>
              <div>
                <DrawerHeader
                  firstname={currentUser && currentUser.firstname}
                  lastname={currentUser && currentUser.lastname}
                />
                <Navigation>
                  {drawerItemsFiltered.map(item => (
                    <NavigationItem
                      key={item.route}
                      active={
                        `${routing.location.pathname.split('/')[1]}` ===
                        `${item.route.split('/')[1]}`
                      }
                      icon={item.icon}
                      onClick={() => {
                        push(item.route);
                      }}
                    >
                      <FormattedMessage {...item.label} />
                    </NavigationItem>
                  ))}
                </Navigation>
              </div>
              <Flex flexDirection="column" justifyContent="flex-end">
                <ContactWrapper>
                  <LogoWrapper>
                    <Icon id="ugent-ge" fillColor="#e85e71" />
                  </LogoWrapper>

                  <ContactGroup>
                    <li>Vakgroep bewegings- en sportwetenschappen</li>
                    <li>Onderzoeksgroep sport pedagogiek</li>
                    <li>
                      Contactpersoon
                      <ul>
                        <li>Prof. L. Haerens</li>
                      </ul>
                    </li>
                    <li>
                      Ontwikkeld met steun van het Fonds Voor Wetenschappelijk
                      Onderzoek
                    </li>
                  </ContactGroup>
                </ContactWrapper>

                <NavigationLogoutWrapper logout={this.logout} />
              </Flex>
            </Drawer>
          )}

        <Switch>
          <LoginRoute exact path={ROUTE_LOGIN} component={Login} />
          <LoginRoute exact path={ROUTE_SIGNUP} component={SignupView} />
          <LoginRoute exact path={ROUTE_FORGOT} component={ForgotLoginView} />
          {tmpCognitoUser && (
            <LoginRoute
              exact
              path={ROUTE_SET_PASSWORD}
              component={SetPasswordView}
            />
          )}
          <PrivateRoute
            path={ROUTE_DISCOVER_RESULT_PDF}
            component={ResultPDFView}
          />
          <PrivateRoute path={ROUTE_DISCOVER} component={Discover} />

          <PrivateRoute path={`${ROUTE_ANALYSE}/(.*)`} component={AnalyseApp} />
          <PrivateRoute path={ROUTE_TIPS} component={Tips} />
          <PrivateRoute path={ROUTE_PROFILE} component={Profile} />
          {/* filter out admin routes */}

          {currentUser &&
            currentUser.admin && (
              <PrivateRoute path={ROUTE_USERS} component={Users} />
            )}
          <PrivateRoute path="/" component={Home} />
          <Redirect to="/" />
        </Switch>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AppRoute.js